export default __webpack_public_path__ + "static/media/home-restaurant-img-17.110bad0f.jpg";